export const GLOBAL_DBNP_MAPPINGS_RESET_STATE = 'GLOBAL_DBNP_MAPPINGS_RESET_STATE';
export const GLOBAL_DBNP_MAPPINGS_CURRENT_ITEM = 'GLOBAL_DBNP_MAPPINGS_CURRENT_ITEM';

export const GLOBAL_DBNP_MAPPINGS_REQUEST_LOADING = 'GLOBAL_DBNP_MAPPINGS_REQUEST_LOADING';
export const GLOBAL_DBNP_MAPPINGS_REQUEST_SUCCESS = 'GLOBAL_DBNP_MAPPINGS_REQUEST_SUCCESS';
export const GLOBAL_DBNP_MAPPINGS_REQUEST_FAILED = 'GLOBAL_DBNP_MAPPINGS_REQUEST_FAILED';

export const GLOBAL_DBNP_MAPPINGS_CURRENT_ACTION = 'GLOBAL_DBNP_MAPPINGS_CURRENT_ACTION';
export const GLOBAL_DBNP_MAPPINGS_RESET_ACTION = 'GLOBAL_DBNP_MAPPINGS_RESET_ACTION';